import angular from 'angular';
import addAdministratorsComponent from './addAdministrators.component';

let addAdministratorsModule = angular.module('addAdministrators', []).component('addAdministrators', addAdministratorsComponent);

export default addAdministratorsModule;



// WEBPACK FOOTER //
// ./app/components/addAdministrators/addAdministrators.js